import { Component } from '@angular/core';
import {User, UserService} from "../../../services/user.service";
import {Page} from "../../../services/api.service";
import {firstValueFrom} from "rxjs";
import { PageEvent, MatPaginatorModule } from "@angular/material/paginator";
import {Attendee, AttendeeQuery, AttendeeService} from "../../../services/attendee.service";
import {Router} from "@angular/router";
import { FooterComponent } from '../../../components/footer/footer.component';
import { MenuBarComponent } from '../../../components/menu-bar/menu-bar.component';
import { AttendanceSummaryComponent } from '../../../components/attendance-summary/attendance-summary.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-view-rooms',
    templateUrl: './view-rooms.component.html',
    styleUrls: ['./view-rooms.component.scss'],
    standalone: true,
    imports: [NgIf, FaIconComponent, MatPaginatorModule, NgFor, AttendanceSummaryComponent, MenuBarComponent, FooterComponent]
})
export class ViewRoomsComponent {


  loading: boolean = false ;
  user?: User ;
  attendances?: Page<Attendee>;

  constructor(
    public $users: UserService,
    public $attendees: AttendeeService,
    public $router: Router
  ) {

  }

  async ngOnInit() {

    this.user = await firstValueFrom(this.$users.getUser()) ;

    await this.loadAttendances(0);
  }

  async loadAttendances(page: number) {

    this.loading = true ;

    const query = new AttendeeQuery();
    const results = await firstValueFrom(this.$attendees.getAttendances(query, page));

    console.log(results);
    this.attendances = results ;

    this.loading = false ;
  }

  async handlePageEvent($event: PageEvent) {
    await this.loadAttendances($event.pageIndex);
  }

  async handleFiltersChanged() {

    await this.loadAttendances(0);
  }

  async reviewRoom(attendee: Attendee) {
    await this.$router.navigate(['/review-room/' + attendee.id.roomId]) ;
  }
}
